import {
  title as enableFlowsTitle,
  id as enableFlowsId,
} from '../../Apps/components/EnableFlowsForAppStatus';
import {
  title as overviewTitle,
  id as overviewId,
} from '../../Apps/components/AppStatusOverview';
import {
  title as contextAwareToggleTitle,
  id as contextAwareToggleId,
} from '../../GenericSteps/ContextAwareToggleStep';
import { WizardStep } from '~/components/organism/Wizard/context/WizardContext';
import { StepId } from '../..';
import { AppStatus__typename } from '~/graphql/types.client';

/**
 * Returns EnableFlowsForAppStatus and AppStatusOverview steps for Wizard
 * @param {AppStatus__typename} typename
 * keywords: wizard, steps, AppStatusOverview, EnableFlowsForAppStatus
 */

type Args = {
  typename: AppStatus__typename;
  withFlows?: boolean;
  withContextAwareToggle?: boolean;
};

const getCommonWizardSteps = ({
  typename,
  withFlows,
  withContextAwareToggle,
}: Args): Array<WizardStep> => {
  const steps: Array<WizardStep> = [];

  if (withFlows) {
    steps.push({
      title: enableFlowsTitle,
      id: enableFlowsId as StepId,
      metadata: { typename },
    });
  }

  if (withContextAwareToggle) {
    steps.push({
      title: contextAwareToggleTitle,
      id: contextAwareToggleId as StepId,
      metadata: { typename },
    });
  }

  steps.push({
    title: overviewTitle,
    id: overviewId as StepId,
    metadata: { typename },
  });

  return steps;
};
export default getCommonWizardSteps;
